<template>
  <div class="list-container">
    <div class="terms-container">
      <div class="legal-protocol">
        <div class="title">
          Información Europea Normalizada sobre el Crédito al Consumo
        </div>

        <div class="desc">
          Nébula Finance, S.A., comprometida con altos estándares de calidad y
          cumplimiento de la normativa europea vigente, te facilita la
          información necesaria para ayudarte a decidir con conocimiento si el
          crédito ofrecido, según tus preferencias manifestadas, se adapta a tus
          necesidades y situación financiera. A continuación, se detallan las
          características esenciales del crédito en formato europeo normalizado
          (Información Europea Normalizada sobre Crédito al Consumo – INECC).
        </div>

        <div class="desc-li">
          1. Identidad y datos de contacto del prestamista:
        </div>

        <table class="protocol-table">
          <tbody>
            <tr>
              <td class="text-left">Prestamista:</td>
              <td class="text-left">Nébula Finance, S.A.</td>
            </tr>
            <tr>
              <td class="text-left">NIF:</td>
              <td class="text-left">A75607945</td>
            </tr>
            <tr>
              <td class="text-left">Dirección:</td>
              <td class="text-left">
                Paseo De La Castellana 194 - Madrid – 28046
              </td>
            </tr>
            <tr>
              <td class="text-left">E-mail:</td>
              <td class="text-left">{{emailNo}}</td>
            </tr>
            <tr>
              <td class="text-left">Sitio web:</td>
              <td class="text-left">www.prestalight.com</td>
            </tr>
            <tr>
              <td class="text-left">Teléfono:</td>
              <td class="text-left">{{servicePhoneNo}}</td>
            </tr>
          </tbody>
        </table>

        <div class="desc-li">
          2. Descripción de las principales características del producto de
          crédito:
        </div>
        <table class="protocol-table">
          <tbody>
            <tr>
              <td class="text-left">Tipo de crédito</td>
              <td class="text-left">Crédito al consumo</td>
            </tr>
            <tr>
              <td class="text-left">Importe total del crédito</td>
              <td class="text-left">
                La cantidad solicitada por el cliente en su Solicitud de
                Préstamo o hasta un máximo de dos mil euros (2.000 €).
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Condiciones para la disposición de los fondos: Es decir, cómo y
                cuándo el consumidor recibirá el dinero.
              </td>
              <td class="text-left">
                El prestamista transferirá el importe del préstamo a la cuenta
                bancaria indicada por el prestatario en la Solicitud de Préstamo
                una vez firmado el contrato.
              </td>
            </tr>
            <tr>
              <td class="text-left">Duración del contrato de crédito</td>
              <td class="text-left">
                {{ period }} días naturales desde la aprobación de la solicitud.
                Si la fecha de vencimiento coincide con un día inhábil, el pago
                se realizará el siguiente día hábil inmediato. No obstante, el
                prestatario podrá extender el plazo del préstamo según las
                Condiciones Generales.
              </td>
            </tr>
            <tr>
              <td class="text-left">Cuotas y orden de pagos</td>
              <td class="text-left">
                El Préstamo podrá tener una duración de hasta sesenta y un (61) días naturales, de conformidad con las Condiciones Particulares, a contar desde la recepción por parte del Prestatario de la Decisión de Préstamo.
                <br />
                <br />

                Intereses calculados:<br />
                Según la fórmula establecida en la Ley 16/2011, de 24 de junio,
                de Contratos de Crédito al Consumo (BOE de 25 de junio).<br />
                <br />
                Intereses y gastos aplicables:<br />
                Al firmar el contrato, el prestatario acepta el siguiente orden
                de aplicación de pagos:<br />
                (1) intereses de demora;<br />
                (2) comisión por gestión efectiva de cobro (“reclamación de
                impago”);<br />
                (3) intereses ordinarios;<br />
                (4) comisión de apertura;<br />
                (5) reembolso del capital principal.
                <br />
                <br />
                Forma de pago:<br />
                (i) a través de métodos especificados en las Condiciones
                Generales;
                <br />(ii) cualquier otro medio que el prestamista disponga
                en el futuro.<br /><br />

                Los pagos se considerarán realizados una vez recibidos en la
                cuenta bancaria del prestamista.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Importe total a pagar: Es decir, el importe del capital prestado
                más los intereses y gastos relacionados con su préstamo
              </td>
              <td class="text-left">
                {{ amount }}<br />
                <br />
                El importe total a pagar por el prestatario depende del importe
                total y del plazo del préstamo.<br />

                Si se aprueba el préstamo, el importe total deberá incluir el
                capital principal, junto con los intereses y la comisión de
                apertura.
              </td>
            </tr>
          </tbody>
        </table>
        <div class="desc-li">3. Coste del crédito</div>
        <table class="protocol-table" separator="cell" flat bordered>
          <tbody>
            <tr>
              <td class="text-left">Tipo deudor</td>
              <td class="text-left">
                Tipo de interés nominal anual (TIN) fijo calculado sobre el
                principal y plazo pactados. El TIN es
                {{ yearRate }} %
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Tasa Anual Equivalente (TAE): Expresa el coste total del
                préstamo como porcentaje anual del importe total del crédito.
                Permite comparar diferentes ofertas.
              </td>
              <td class="text-left">
                La TAE es {{ monthRate }} % <br />
                La Tasa Anual Equivalente ha sido calculada según la fórmula
                contenida en el Artículo 32 y Anexo I de la Ley 16/2011, de 24
                de junio, de Contratos de Crédito al Consumo.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                ¿Es obligatoria la contratación de seguros u otros servicios? Si
                los costes de estos servicios no son conocidos por el
                prestamista, no están incluidos en la TAE.
              </td>
              <td class="text-left">No es obligatorio.</td>
            </tr>
            <tr>
              <td class="text-left">Costes relacionados</td>
              <td class="text-left">
                Comisión de apertura sobre el capital principal.
              </td>
            </tr>
            <tr>
              <td class="text-left">Condiciones de modificación de costes</td>
              <td class="text-left">
                Solo se incrementarán en caso de prórroga, suscripción de plan
                de pagos o impago según el contrato.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Costes por impago El impago puede tener graves consecuencias y
                dificultar la obtención de crédito.
              </td>
              <td class="text-left">
                En caso de impago en la fecha de vencimiento del préstamo: el
                prestatario pagará una penalización por demora, es decir, por
                pagos atrasados, del {{lateFee}}% diario con un máximo del 100% del
                importe principal, además del importe impagado. También se
                aplicará una comisión fija de reclamación por impago de {{collectionFee}} euros
                por cada incidencia de impago. Esta comisión será exigible por
                cada caso de retraso en el pago y es independiente de cualquier
                otro cargo o interés que pueda aplicarse según las Condiciones
                Generales. En caso de impago en el reembolso del préstamo, el
                prestamista se reserva el derecho a reclamar judicialmente el
                importe del préstamo, ceder los derechos de crédito contra el
                prestatario a un tercero o comunicar la situación de impago,
                previa notificación, a ficheros de solvencia y crédito. El
                prestamista podrá ofrecer al prestatario la posibilidad de
                suscribirse a un plan de pagos en caso de que el préstamo no se
                haya abonado en la fecha de vencimiento, lo cual implicará una
                comisión de gestión que será comunicada al prestatario antes de
                su suscripción al plan.
              </td>
            </tr>
          </tbody>
        </table>
        <div class="desc-li">4. Otros aspectos legales importantes</div>
        <table class="protocol-table" separator="cell" flat bordered>
          <thead></thead>
          <tbody>
            <tr>
              <td class="text-left">
                Derecho de desistimiento Tienes derecho a desistir del contrato
                de préstamo en un plazo de 14 días naturales
              </td>
              <td class="text-left">
                El prestatario tendrá un plazo de catorce (14) días naturales
                desde la fecha de emisión de la decisión del préstamo para
                desistir del contrato, sin indicar los motivos y sin
                penalización alguna. En caso de desistimiento, el prestatario no
                tendrá que abonar al prestamista ninguna penalización,
                únicamente deberá reembolsar los intereses devengados sobre el
                capital prestado entre la fecha de disposición del préstamo y la
                fecha de devolución del capital, así como la comisión de
                apertura. Para cancelar el préstamo, el prestatario enviará al
                prestamista una comunicación escrita que incluya el nombre
                completo y DNI/NIE del prestatario, declaración de su voluntad
                de cancelar el préstamo, número de referencia del contrato
                actual, lugar y fecha de la solicitud y firma del prestatario.
                Se considerará realizado el desistimiento si, antes de finalizar
                el plazo de desistimiento, el prestatario ha enviado la
                notificación al domicilio del prestamista.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Reembolso anticipado. Tienes derecho a reembolsar
                anticipadamente el crédito, total o parcialmente, en cualquier
                momento.
              </td>
              <td class="text-left">
                El prestatario tiene derecho a reembolsar el préstamo, en su
                totalidad o en parte, en cualquier momento antes de la fecha de
                vencimiento acordada.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                El prestamista tiene derecho a una compensación en caso de
                reembolso anticipado.
              </td>
              <td class="text-left">
                En el momento de realizar el reembolso anticipado, el
                prestatario deberá abonar el importe del préstamo, los intereses
                correspondientes a los días transcurridos desde la emisión de la
                transferencia por parte del prestamista y, en su caso, la
                comisión de apertura y/o cualquier otro cargo acordado. El
                reembolso anticipado no exime al prestatario del pago de la
                comisión de apertura.<br />
                Sin perjuicio de lo anterior, el prestamista tendrá derecho a
                una compensación justa y objetivamente justificada por los
                costes derivados directamente del reembolso anticipado del
                préstamo. La compensación no podrá exceder del 0,5% del importe
                del préstamo reembolsado anticipadamente.
              </td>
            </tr>
            <tr>
              <td class="text-left">Consulta de bases de datos</td>
              <td class="text-left">
                El prestamista le informará inmediata y gratuitamente sobre el
                resultado de la consulta en una base de datos en caso de rechazo
                de la solicitud de crédito. Esto no será aplicable si la
                difusión de dicha información estuviera prohibida por la
                legislación de protección de datos personales o fuera contraria
                a objetivos de orden público o seguridad pública. El prestamista
                podrá obtener información relativa al historial crediticio y
                posiciones de riesgo de proveedores de servicios de información
                de solvencia y crédito con fines de análisis y, en su caso,
                concesión, seguimiento y control de la financiación.
              </td>
            </tr>
            <tr>
              <td class="text-left">Derecho a un proyecto del contrato</td>
              <td class="text-left">
                El prestatario tiene derecho, previa solicitud, a obtener
                gratuitamente una copia del proyecto de contrato de préstamo.
                Esta disposición no será aplicable si, en el momento de la
                solicitud, el prestamista no está dispuesto a celebrar el
                contrato de préstamo con el prestatario.
              </td>
            </tr>
            <tr>
              <td class="text-left">
                Validez de la información precontractual
              </td>
              <td class="text-left">
                La información proporcionada es válida durante 7 días desde su
                entrega al solicitante.
              </td>
            </tr>
          </tbody>
        </table>
        <div class="desc-li">
          5. Información adicional en caso de comercialización a distancia de
          servicios financieros.
        </div>
        <table class="protocol-table" separator="cell" flat bordered>
          <thead></thead>
          <tbody>
            <tr>
              <td colspan="2" class="text-left">
                a) En relación con el Prestamista
              </td>
            </tr>
            <tr>
              <td class="text-left">Prestamista:</td>
              <td class="text-left">Nébula Finance, S.A.</td>
            </tr>
            <tr>
              <td class="text-left">Dirección:</td>
              <td class="text-left">
                Paseo De La Castellana 194 - Madrid – 28046
              </td>
            </tr>
            <tr>
              <td class="text-left">Teléfono:</td>
              <td class="text-left">{{servicePhoneNo}}</td>
            </tr>
            <tr>
              <td class="text-left">Correo electrónico:</td>
              <td class="text-left">{{emailNo}}</td>
            </tr>
            <tr>
              <td class="text-left">Sitio web:</td>
              <td class="text-left">www.prestalight.com</td>
            </tr>
            <tr>
              <td class="text-left">Registro:</td>
              <td class="text-left">
                Registro Mercantil de Madrid, NIF: A75607945
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-left">
                b) En relación con el contrato de crédito
              </td>
            </tr>
            <tr>
              <td class="text-left">Ejercicio del derecho de desistimiento</td>
              <td class="text-left">
                El prestatario dispone de 14 días naturales para desistir del
                contrato, notificándolo al prestamista por correo postal a
                [Paseo De La Castellana 194 - Madrid – 28046] o al correo
                electrónico [{{emailNo}}] , indicando su nombre,
                apellidos, número de documento de identidad y número de
                contrato. El prestatario deberá reembolsar el capital prestado y
                los intereses devengados sobre dicho capital entre la fecha de
                disposición del crédito y la fecha de devolución del capital en
                un plazo de treinta días naturales tras el envío de dicha
                notificación.
              </td>
            </tr>
            <tr>
              <td class="text-left">Ley aplicable y jurisdicción</td>
              <td class="text-left">
                El contrato se regirá por la legislación española,
                específicamente por las normas generales en materia de consumo,
                crédito, publicidad, protección de datos y prevención del
                blanqueo de capitales. El tribunal competente para cualquier
                reclamación legal derivada del mismo será el del domicilio del
                prestatario.
              </td>
            </tr>
            <tr>
              <td class="text-left">Régimen lingüístico</td>
              <td class="text-left">
                La información y condiciones contractuales se facilitan en
                español. Durante la vigencia del contrato, y con el
                consentimiento del prestatario, la comunicación entre
                prestatario y prestamista será en español.
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-left">
                c) En relación con los recursos
              </td>
            </tr>
            <tr>
              <td class="text-left">Procedimientos extrajudiciales</td>
              <td class="text-left">
                En virtud de la relación de mutua confianza establecida, las
                partes intentarán resolver cualquier controversia, disputa o
                reclamación derivada del contrato de préstamo mediante
                negociaciones mutuamente acordadas. Adicionalmente, el
                prestamista no es miembro de ningún sistema extrajudicial de
                resolución de conflictos. En todo caso, cualquier consumidor,
                para la resolución de disputas de consumo en línea conforme al
                artículo 14.1 del Reglamento (UE) 524/2013, podrá acudir a la
                plataforma europea de resolución de litigios en línea facilitada
                por la Comisión Europea en el siguiente enlace:
                http://ec.europa.eu/consumers/odr/. Esta plataforma sólo es
                aplicable a consumidores (prestatarios) residentes en el Espacio
                Económico Europeo que deseen presentar una reclamación contra el
                prestamista. Por lo tanto, es incompatible con conflictos de
                consumidores situados en terceros países fuera del Espacio
                Económico Europeo. El prestamista no está obligado a utilizar
                dicho canal de resolución de conflictos ni se compromete a
                hacerlo. Si tiene cualquier queja o inquietud, puede contactar
                con nosotros enviando un correo electrónico a
                [{{emailNo}}] o escribiéndonos a [Paseo De La
                Castellana 194 - Madrid – 28046]
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, inject, markRaw, onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { channelMethods, postToApp } from '@/utils/channelMethod';
import { formatDateTime, formatNumber, getCredential } from '@/utils';
import { email, companyName } from '@/utils/orderConfig';
import { _fetchJustifyLiquidate } from '@/api/help';

export default {
  name: 'registerPage',
  methods: { emailL: email, companyNameL: companyName, formatDateTime },
  setup() {
    const loading = ref(false);
    const route = useRoute();

    const isInApp = computed(() => {
      return getCredential();
    });

    const period = computed(() => {
      return route.query.period ?? '-';
    });

    const amount = computed(() => {
      return route.query.amount ?? '-';
    });

    const collectionFee = computed(() => {
      return route.query.colFee ?? '-';
    });

    const lateFee = computed(() => {
      return route.query.lateFee ?? '-';
    });

    const yearRate = computed(() => {
      let result = route.query.yearRate;
      if (result) {
        return formatNumber(result);
      }
      return result ?? '-';
    });

    const monthRate = computed(() => {
      let result = route.query.monthRate;
      if (result) {
        return formatNumber(result);
      }
      return result ?? '-';
    });

    const openLink = (url: any) => {
      window.open(url, '_blank');
    };

    const formatMoney = (value: number) => {};

    const resultData = ref<any>();

    const emailNo = computed(() => {
      return resultData.value?.filter((item: any) => item.expand === "3")[0]?.monitor ?? 'clientes@prestalight.com';
    });

    const servicePhoneNo = computed(() => {
      return resultData.value?.filter((item: any) => item.expand === "2")[0]?.monitor ?? '917905850';
    });

    const onLoadServiceInfo = () => {
      _fetchJustifyLiquidate({})
        .then((res: any) => {
          console.log('_repaymentAgreementInfo: ', res['justifyLiquidate']);
          const resultList = res['justifyLiquidate']
          if (resultList) {
            resultData.value = resultList;
          }
        })
        .catch(err => {})
        .finally(() => {
        });
    };

    onMounted(() => {
      document.title = 'Terms of Use';
      onLoadServiceInfo();
    });

    return {
      loading,
      period,
      collectionFee,
      lateFee,
      amount,
      yearRate,
      monthRate,
      formatMoney,
      emailNo,
      servicePhoneNo
    };
  }
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100vw;
  height: 100vh;
  max-width: $max-width;
  position: relative;

  display: flex;
  flex-direction: column;
}
</style>
